import { useCallback, useEffect, useState } from 'react';
import { useIpeAuth } from '@/context/IpeAuthContext';
import {
  RECHARGE_CART_CHANGED_EVENT,
  getRechargeCartCount,
  getRechargeCartItems,
} from '@/utils/ipeRechargeCart';

export function useIpeRechargeCart() {
  const { user } = useIpeAuth();
  const userId = user?.id ?? user?._id;

  const read = useCallback(() => getRechargeCartItems(userId), [userId]);
  const readCount = useCallback(() => getRechargeCartCount(userId), [userId]);

  const [items, setItems] = useState(() => read());
  const [count, setCount] = useState(() => readCount());

  useEffect(() => {
    setItems(read());
    setCount(readCount());
  }, [read, readCount]);

  useEffect(() => {
    const sync = () => {
      setItems(read());
      setCount(readCount());
    };
    window.addEventListener(RECHARGE_CART_CHANGED_EVENT, sync);
    return () => window.removeEventListener(RECHARGE_CART_CHANGED_EVENT, sync);
  }, [read, readCount]);

  return { items, count, userId };
}
